const { getAll, get } = require("@/utilities/querySelector");

/**
 * Open modal
 */
getAll('.open-modal, .open-modal > a').forEach(opener => {
    opener.addEventListener('click', function () {
        const id = opener.getAttribute('href');
        get(`.modal${id}`)?.style?.setProperty('display', 'flex');
    });
});

/**
 * Close modal on x click
 */
getAll('.modal-close').forEach(closer => {
    closer.addEventListener('click', function () {
        const modal = /** @type {HTMLElement} */ (closer.closest('.modal'));
        modal.style.display = 'none';
    });
});

/**
 * Scroll to submit message on submit button click
 */

export const modalContainer = get('#modal-enquiry-form');

export const modalForm = modalContainer?.querySelector('.wpcf7');

export const modalMain = modalContainer?.querySelector('.modal-content');

modalForm?.addEventListener('wpcf7submit', scrollToBottom);

function scrollToBottom() {
    setTimeout(() => {
        modalContainer.scrollTop = modalContainer.scrollHeight;
    }, 700)
};


